<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "Solutions",

  metaInfo: { title: "Software tailored to the needs of the marine industry" },

  extends: View,

  mixins: [
    LoadSections([
      "hero-alt",
      //'solutions',
      "solutions2",
      "solutions3",
      "solutions4",
      "affiliates",
      "info",
    ]),
  ],

  props: {
    id: {
      type: String,
      default: "about",
    },
  },
};
</script>
